import React, { PureComponent } from 'react';
import './guest-popup.scss';
import { connect } from 'react-redux';
import GuestComponent from './GuestComponent';

class GuestPopup extends PureComponent {
  popupRef = React.createRef();

  onClick = e => {
    const { showGuestPopup } = this.props;
    if (this.popupRef.current.contains(e.target)) {
      return;
    }
    showGuestPopup(false);
  };

  onCloseClick = e => {
    const { showGuestPopup } = this.props;
    e.preventDefault();
    e.stopPropagation();
    showGuestPopup(false);
  };

  render() {
    return (
      <div onClick={this.onClick} className="guest-popup-wrapper">
        <div ref={this.popupRef} className="guest-popup-content">
          <i className="icon-close" onClick={this.onCloseClick} />
          <GuestComponent />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.userInfo,
  locale: state.i18n.locale,
});

export default connect(mapStateToProps)(GuestPopup);
